<template>
  <b-card no-body class="mb-1 w-100">
    <b-card-header header-tag="header" class="p-1" role="tab">
      <div id="cardTitle">
        <b-button
          :class="visible ? null : 'collapsed'"
          :aria-expanded="visible ? 'true' : 'false'"
          :aria-controls="accordionId"
          block
          @click="visible = !visible"
        >
          <i class="bi bi-caret-right-fill"></i>
        </b-button>

        <div class="alignTitleAndTrafficLight">
          {{ titleOfTheCard }}

          <div
            :class="{
              redDot: overallTrafficLight[0].isRed,
              orangeDot: overallTrafficLight[1].isOrange,
              greenDot: overallTrafficLight[2].isGreen
            }"
          ></div>
        </div>

        <b-button v-if="!getIsSupervisor" size="sm" pill variant="link" @click="navigateToEdit">
          <i class="bi bi-pencil-fill"></i>
        </b-button>
      </div>
    </b-card-header>
    <b-collapse :id="accordionId" v-model="visible" invisible accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <div class="gridCard">
          <div v-for="cardContent in cardsContent" :key="cardContent.id">
            <status-report-card :card-content="cardContent"></status-report-card>
          </div>
        </div>
        <h2 id="title">{{ $t(localeConsts.risks) }}</h2>
        <b-table class="riskTable text-center" :fields="columns" :items="risks" striped></b-table>
        <h2 v-show="isCommentsTableNotEmpty || getIsSupervisor" id="title">{{ $t(localeConsts.comments) }}</h2>
        <comment-data-table
          v-show="isCommentsTableNotEmpty || getIsSupervisor"
          :status-report-id="statusReportContent.id"
          :comments-u-r-i="'status-report-comments'"
          :comments-params="commentsParams"
          @tableData="tableData = $event"
        ></comment-data-table>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import StatusReportCard from './StatusReportCard'
import CommentDataTable from '../../../util/CommentComponent/CommentDataTable.vue'
import axios from '../../../../axios'
import mapGettersMixin from '../../../mixins/mapGettersMixin'

export default {
  name: 'StatusReportEntry',
  components: {
    StatusReportCard,
    CommentDataTable
  },
  mixins: [mapGettersMixin],
  props: {
    titleOfTheCard: String,
    statusReportContent: {}
  },
  data() {
    return {
      visible: true,
      accordionId: this.statusReportContent.id.toString(),
      localeConsts: {
        statusReportsTitle: 'STATUSREPORTS.TITLE',
        overallStatus: 'STATUSREPORTS.OVERALL_STATUS',
        workload: 'STATUSREPORTS.WORK_LOAD',
        quality: 'STATUSREPORTS.QUALITY',
        teamSpirit: 'STATUSREPORTS.TEAM_SPIRIT',
        schedule: 'STATUSREPORTS.SCHEDULE',
        budget: 'STATUSREPORTS.BUDGET',
        risks: 'STATUSREPORTS.RISKS',
        riskLabel: 'STATUSREPORTS.RISK_IDENTIFIED',
        riskCause: 'STATUSREPORTS.CAUSE',
        riskConsequences: 'STATUSREPORTS.CONSEQUENCES',
        riskMeasure: 'STATUSREPORTS.COUNTER_MEASURES',
        comments: 'STATUSREPORTS.COMMENTS'
      },
      commentsParams: {
        params: {
          report_id: this.statusReportContent.id
        }
      },
      risks: [],
      tableData: []
    }
  },
  computed: {
    cardsContent() {
      return [
        {
          title: this.$i18n.t(this.localeConsts.overallStatus),
          content: this.statusReportContent.global_status_comments,
          status: this.mapIntStatusLevelToString(this.statusReportContent.global_status_level)
        },
        {
          title: this.$i18n.t(this.localeConsts.workload),
          content: this.statusReportContent.workload_comments,
          status: this.mapIntStatusLevelToString(this.statusReportContent.workload_level)
        },
        {
          title: this.$i18n.t(this.localeConsts.budget),
          content: this.statusReportContent.budget_comments,
          status: this.mapIntStatusLevelToString(this.statusReportContent.budget_level)
        },
        {
          title: this.$i18n.t(this.localeConsts.quality),
          content: this.statusReportContent.quality_comments,
          status: this.mapIntStatusLevelToString(this.statusReportContent.quality_level)
        },
        {
          title: this.$i18n.t(this.localeConsts.schedule),
          content: this.statusReportContent.schedule_comments,
          status: this.mapIntStatusLevelToString(this.statusReportContent.schedule_level)
        },
        {
          title: this.$i18n.t(this.localeConsts.teamSpirit),
          content: this.statusReportContent.team_spirit_comments,
          status: this.mapIntStatusLevelToString(this.statusReportContent.team_spirit_level)
        }
      ]
    },
    overallTrafficLight() {
      return [
        { isRed: this.cardsContent[0].status == 'severe' }, //eslint-disable-line
        { isOrange: this.cardsContent[0].status == 'critical' }, //eslint-disable-line
        { isGreen: this.cardsContent[0].status == 'good' } //eslint-disable-line
      ]
    },
    columns() {
      return [
        {
          label: this.$i18n.t(this.localeConsts.riskLabel),
          key: 'identified_risk',
          thClass: 'riskTableHeader'
        },
        { label: this.$i18n.t(this.localeConsts.riskCause), key: 'causes', thClass: 'riskTableHeader' },
        {
          label: this.$i18n.t(this.localeConsts.riskConsequences),
          key: 'consequences',
          thClass: 'riskTableHeader'
        },
        {
          label: this.$i18n.t(this.localeConsts.riskMeasure),
          key: 'taken_measures',
          thClass: 'riskTableHeader'
        }
      ]
    },
    isCommentsTableNotEmpty() {
      return this.tableData.length > 0
    }
  },
  mounted() {
    this.fetchRisks()
  },
  methods: {
    mapIntStatusLevelToString(statusInt) {
      return statusInt == 0 ? 'good' : statusInt == 1 ? 'critical' : 'severe' //eslint-disable-line
    },
    async fetchRisks() {
      this.risks = (await axios.get(`status-report-identified-risks/?report_id=${this.statusReportContent.id}`)).data
    },
    navigateToEdit() {
      this.$router.push({ name: 'CreateEditStatusReport', params: { id: this.statusReportContent.id } })
    }
  }
}
</script>

<style>
b-card {
  width: inherit;
}

#title {
  color: #8b69a9;
}

/* Entry Title */

#cardTitle {
  display: inline-flex;
  align-content: space-around;
}

.alignTitleAndTrafficLight {
  display: flex;
  width: 195px;
  justify-content: space-between;
  align-items: center;
}
/* Traffic Lights */

.dotWrapper {
  padding-right: 10px;
  padding-bottom: 10px;
}

.redDot {
  background-color: red;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding-right: 10px;
}

.orangeDot {
  background-color: orange;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding-right: 10px;
}

.greenDot {
  background-color: rgb(0, 190, 0);
  border-radius: 50%;
  height: 20px;
  width: 20px;
  padding-right: 10px;
}

/* Cards */

.gridCard {
  display: grid;
  grid-template: auto auto 50px 1fr / 33% 33% 33%;
  min-width: 0;
}

.gridCard > div {
  min-width: 0;
}

.riskTable td {
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
}

/* Risktable */

.riskTable {
  grid-column: 1 / 4;
  grid-row: 4;
  border-radius: 10px;
}

.riskTableHeader {
  background-color: #c1afd1 !important;
  color: #451a6e !important;
}
</style>
